import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { PoolGameCoreService } from './pool-game-core.service';
import { PoolGameSelectorComponent } from './pool-game-selector/pool-game-selector.component';

@NgModule({
  declarations: [PoolGameSelectorComponent],
  imports: [CommonModule, ReactiveFormsModule, SharedModule],
  providers: [PoolGameCoreService],
  exports: [PoolGameSelectorComponent],
})
export class PoolGameCoreModule {}
